<h2 mat-dialog-title>{{ 'users.policyGroups.manageAddPolicyTitle' | t }}</h2>

<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="formModel.resources.length > 0; else selectType">
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
    <mat-accordion>
      <mat-expansion-panel [expanded]="true" *ngIf="formModel.type === 'camera'">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ 'common.cameras' | t }} </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="!formModel.selectAll; else allResources">
          <mat-card *ngFor="let camera of data.policy.cameras">
            {{ camera.name }}
            <button
              class="remove-icon"
              mat-icon-button
              [matTooltip]="'common.remove' | t"
              color="danger"
              icon="close"
              (click)="removeCamera(camera)"
            >
              <mat-icon class="fa-solid fa-x"></mat-icon>
            </button>
          </mat-card>
        </ng-container>
        <button
          mat-button
          class="fs-mt-3"
          color="success"
          (click)="addCameras()"
          [disabled]="formModel.selectAll"
        >
          <sn-icon class="add-icon fs-mr-2" fontSet="fal" fontIcon="fa-video"></sn-icon> {{ 'common.addCameras' | t }}
        </button>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true" *ngIf="formModel.type === 'Camera Tag'">
        <mat-expansion-panel-header>
          <mat-panel-title> {{ 'users.policyGroups.cameraTags' | t }} </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="!formModel.selectAll">
          <mat-card *ngFor="let tag of data.policy.tags">
            {{ tag.name }}
            <button
              class="remove-icon"
              mat-icon-button
              [matTooltip]="'common.remove' | t"
              color="danger"
              icon="close"
              (click)="removeCameraTag(tag)"
            >
              <mat-icon class="fa-solid fa-x"></mat-icon>
            </button>
          </mat-card>
        </ng-container>
        <button
          mat-button
          class="fs-mt-3"
          color="success"
          (click)="addCameraTags()"
          [disabled]="formModel.selectAll"
        >
          <sn-icon class="add-icon fs-mr-1" fontSet="fal" fontIcon="fa-tag"></sn-icon> {{ 'users.policyGroups.addCameraTags' | t }}
        </button>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true" *ngIf="formModel.type === 'Location Tag'">
        <mat-expansion-panel-header>
          <mat-panel-title> {{ 'users.policyGroups.locationTags' | t }} </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="!formModel.selectAll">
          <mat-card *ngFor="let tag of data.policy.tags">
            {{ tag.name }}
            <button
              class="remove-icon"
              mat-icon-button
              [matTooltip]="'common.remove' | t"
              color="danger"
              icon="close"
              (click)="removeLocationTag(tag)"
            >
              <mat-icon class="fa-solid fa-x"></mat-icon>
            </button>
          </mat-card>
        </ng-container>
        <button
          mat-button
          class="fs-mt-3"
          color="success"
          (click)="addLocationTags()"
          [disabled]="formModel.selectAll"
        >
          <sn-icon class="add-icon fs-mr-1" fontSet="fal" fontIcon="fa-tag"></sn-icon> {{ 'users.policyGroups.addLocationTags' | t }}
        </button>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" *ngIf="formModel.type === 'location'">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ 'common.locations' | t }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="!formModel.selectAll; else allResources">
          <mat-card *ngFor="let location of data.policy.locations">
            {{ location.name }}
            <button
              class="remove-icon"
              mat-icon-button
              [matTooltip]="'common.remove' | t"
              color="danger"
              icon="close"
              (click)="removeLocation(location)"
            >
              <mat-icon class="fa-solid fa-x"></mat-icon>
            </button>
          </mat-card>
        </ng-container>
        <button
          mat-button
          class="fs-mt-3"
          color="success"
          (click)="addLocations()"
          [disabled]="formModel.selectAll"
        >
          <sn-icon class="add-icon fs-mr-2" fontSet="fal" fontIcon="fa-city"></sn-icon> {{ 'users.policyGroups.addLocations' | t }}
        </button>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" *ngIf="formModel.type === 'layer'">
        <mat-expansion-panel-header>
          <mat-panel-title> {{ 'common.layers' | t }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="!formModel.selectAll; else allResources">
          <mat-card *ngFor="let layer of data.policy.layers">
            {{ layer.name }}
            <button
              class="remove-icon"
              mat-icon-button
              [matTooltip]="'common.remove' | t"
              color="danger"
              icon="close"
              (click)="removeLayer(layer)"
            >
              <mat-icon class="fa-solid fa-x"></mat-icon>
            </button>
          </mat-card>
        </ng-container>
        <button
          mat-button
          class="fs-mt-3"
          color="success"
          (click)="addLayers()"
          [disabled]="formModel.selectAll"
        >
          <sn-icon class="add-icon fs-mr-2" fontSet="fal" fontIcon="fa-layer-group"></sn-icon>{{ 'users.policyGroups.addLayers' | t }}
        </button>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" *ngIf="formModel.type === 'permission'">
        <mat-expansion-panel-header>
          <mat-panel-title> {{ 'common.permissions' | t }}</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card *ngFor="let permission of customPolicy">
          {{ permission.name }}
          <button
            class="remove-icon"
            mat-icon-button
            [matTooltip]="'common.remove' | t"
            color="danger"
            icon="close"
            (click)="removePermission(permission)"
          >
            <mat-icon class="fa-solid fa-x"></mat-icon>
          </button>
        </mat-card>
        <button
          mat-button
          class="fs-mt-3"
          color="success"
          (click)="addPermissions()"
          [disabled]="formModel.selectAll"
        >
          <sn-icon class="add-icon fs-mr-1" fontSet="fal" fontIcon="fa-filter-list"></sn-icon> {{ 'users.policyGroups.addPermissions' | t }}
        </button>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="danger" mat-button mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button
    mat-button
    [disabled]="form.invalid"
    mat-button
    color="success"
    (click)="submit()"
    cdkFocusInitial
  >
    {{ 'common.save' | t }}
  </button>
</mat-dialog-actions>

<ng-template #selectType>
  <div class="fs-col">
    <div class="fs-row">
      <h3>{{ 'users.policyGroups.chooseResourceType' | t }}:</h3>
    </div>
    <div class="fs-row">
      <div class="fs-col">
        <div class="resource-item" (click)="setCameraResource(true)">
          <h4>{{ 'common.cameras' | t }}</h4>
          <p>
            {{ 'users.policyGroups.chooseResourceTypeCamera' | t }}
          </p>
        </div>
        <div class="resource-item" (click)="setCameraTagsResource(true)">
          <h4>{{ 'users.policyGroups.cameraTags' | t }}</h4>
          <p>
            {{ 'users.policyGroups.chooseResourceTypeCameraTags' | t }}
          </p>
        </div>
        <div class="resource-item" (click)="setLocationResource(true)">
          <h4>{{ 'common.locations' | t }}</h4>
          <p>
            {{ 'users.policyGroups.chooseResourceTypeLocation' | t }}
          </p>
        </div>
        <div class="resource-item" (click)="setLocationTagResource(true)">
          <h4>{{ 'users.policyGroups.locationTags' | t }}</h4>
          <p>
            {{ 'users.policyGroups.chooseResourceTypeLocationTags' | t }}
          </p>
        </div>
        <div class="resource-item" (click)="setLayerResource(true)">
          <h4>{{ 'common.layers' | t }}</h4>
          <p>
            {{ 'users.policyGroups.chooseResourceTypeLayer' | t }}
          </p>
        </div>
        <div class="resource-item" (click)="setCustomResource(true)">
          <h4>{{ 'users.policyGroups.customPolicy' | t }}</h4>
          <p>{{ 'users.policyGroups.chooseResourceTypeCustomPolicy' | t }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #allResources>
  <mat-card class="allResouresCard">
    {{ getAllSelectedText() }}
    <sn-icon fontSet="fal" fontIcon="fa-circle-check"></sn-icon>
  </mat-card>
</ng-template>
